import { ObjectToUnion } from "../../types/sharedTypes"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export const FEATURE = {
  desk: "desk",
  visitor: "visitor",
  home: "home",
  room: "room",
  sign: "sign",
  asset: "asset",
} as const

export type Feature = ObjectToUnion<typeof FEATURE>
export type PaymentState = {
  hasPaid: boolean
  locked: {
    [FEATURE.desk]: boolean
    [FEATURE.visitor]: boolean
    [FEATURE.home]: boolean
    [FEATURE.room]: boolean
    [FEATURE.sign]: boolean
    [FEATURE.asset]: boolean
  }
}

const initialState: PaymentState = {
  hasPaid: true,
  locked: {
    [FEATURE.desk]: false,
    [FEATURE.visitor]: false,
    [FEATURE.home]: false,
    [FEATURE.room]: false,
    [FEATURE.sign]: false,
    [FEATURE.asset]: false,
  },
}

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    setHasPaid: (state, { payload }: PayloadAction<Feature | null>) => {
      /**
       * Only ever dispatched in response to a 402, so the account is always
       * unpaid here. A `null` payload just means we couldn't map the request
       * URL to a specific feature (e.g. /solutions/ or /buildings/) — it must
       * NOT flip the user back to paid or clear feature locks set by sibling
       * 402s, otherwise the payment-required screen silently disappears.
       */
      state.hasPaid = false

      if (payload) {
        state.locked[FEATURE[payload]] = true
      }
    },
  },
})

export const paymentReducer = paymentSlice.reducer

export const { setHasPaid } = paymentSlice.actions
